<!-- 控制台账号信息 -->
<template>
  <div class="appconsole">
    <div class="userContent width">
      <div class="userNew">
        <span>账号信息</span>
        <span>安全设置</span>
        <span>实名认证</span>
      </div>
      <div class="userinfo">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>账户信息</span>
            <router-link to="/appUserInfo">
              <el-button style="float: right; padding: 3px 0" type="text">更多信息</el-button>
            </router-link>
          </div>
          <div class="userinfoItem">
            <div class="Iteminfo">
              <div class="itemLab">
                <i class="el-icon-user"></i>
                <span class="userTitle">用户名：</span>
                <span class="userCon">{{userdata.number}}</span>
              </div>
              <div class="itemLab">
                <i class="el-icon-message"></i>
                <span class="userTitle">邮箱：</span>
                <span class="userCon">{{userdata.email}}</span>
              </div>
              <div class="itemLab">
                <div class="renLeft">
                  <i class="el-icon-collection-tag"></i>
                  <span>认证信息：</span>
                </div>
                <div class="itemThree">
                  <div class="itemThreeItem wei">
                    <i class="el-icon-warning-outline"></i>
                    <span>未实名认证</span>
                    <el-link type="primary" :underline="false">去认证</el-link>
                  </div>
                  <div class="itemThreeItem geren">
                    <i class="el-icon-finished"></i>
                    <span>个人认证</span>
                    <el-link type="primary" :underline="false">升级为企业认证</el-link>
                  </div>
                  <div class="itemThreeItem qiye">
                    <i class="el-icon-school"></i>
                    <span>企业认证</span>
                    <!-- <el-link type="primary" :underline="false">去认证</el-link> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="Iteminfo">
              <div class="itemLab">
                <i class="el-icon-user"></i>
                <span class="userTitle">账号ID：</span>
                <span class="userCon">{{userdata.userid}}</span>
              </div>
              <div class="itemLab">
                <i class="el-icon-time"></i>
                <span class="userTitle">注册时间：</span>
                <span class="userCon">{{userdata.add_time}}</span>
              </div>
            </div>
            <div class="Iteminfo itemLabLast">
              <img src="../assets/images/login.jpg" alt />
            </div>
          </div>
        </el-card>
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>资源中心</span>
          </div>
          <div class="resCenter clearfix">
            <span v-for="(item,i) in ziyuaninfo" :key="i">{{item.appname}}</span>
          </div>
        </el-card>
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>费用统计</span>
            <el-button style="float: right; padding: 3px 0" type="text">费用中心</el-button>
          </div>
          <div class="outlay">
            <div id="myChart" :style="{width: '100%', height: '300px'}"></div>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { Footer },
  props: {},
  data() {
    return {
      userdata: {},
      costinfo: [],
      ziyuaninfo: [],
      dataMon: [],
      dataNum: [],
      newsData: {},
    }
  },
  computed: {},
  watch: {},
  created() {
    // this.getListData()
    if (sessionStorage.getItem('codes')) {
      this.getListData()
    } else {
      this.$router.push('/login')
    }
  },
  mounted() {},
  methods: {
    async getListData() {
      const userinfo = await this.$http.post('/userinfo', {
        codes: sessionStorage.getItem('codes'),
      })
      const costinfo = await this.$http.post('/costinfo', {
        codes: sessionStorage.getItem('codes'),
      })
      const ziyuaninfo = await this.$http.post('/ziyuaninfo', {
        codes: sessionStorage.getItem('codes'),
      })
      this.costinfo = costinfo.data.series
      this.ziyuaninfo = ziyuaninfo.data.data
      this.userdata = userinfo.data.userdata
      this.newsData = userinfo.data.messagedata
      console.log(this.newsData)
      for (let index = 0; index < this.costinfo.length; index++) {
        // const element = this.costinfo[index].month
        // const dataNum = this.costinfo[index].total_amount
        this.dataMon.push(this.costinfo[index].month)
        this.dataNum.push(this.costinfo[index].total_amount)
      }
      this.dataMon = JSON.stringify(this.dataMon)
      this.dataNum = JSON.stringify(this.dataNum)
      this.drawLine()
    },

    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      myChart.setOption({
        title: false,
        tooltip: {},
        xAxis: {
          data: JSON.parse(this.dataMon),
        },
        yAxis: {},
        series: [
          {
            name: 'money',
            type: 'bar',
            data: JSON.parse(this.dataNum),
          },
        ],
      })
    },
  },
}
</script>

<style lang="less" scoped>
.userContent {
  display: flex;
  margin-bottom: 10px;
}
.userinfo {
  flex: 2;
  margin-left: 10px;
}
.userNew {
  flex: 1;
  max-width: 200px;
}
.userinfoItem {
  display: flex;
  .Iteminfo {
    flex: 2;
    justify-content: center;
    align-items: center;

    .itemLab {
      display: flex;
      margin-bottom: 20px;
      i {
        flex: 1;
        font-size: 35px;
        max-width: 36px;
        color: #3a8ee6;
        margin-right: 10px;
      }
      .userTitle {
        flex: 1;
        max-width: 70px;
        line-height: 35px;
      }
      .userCon {
        line-height: 35px;
      }

      .renLeft {
        display: flex;
        flex: 2;
        max-width: 120px;
        span {
          flex: 1;
          line-height: 35px;
          max-width: 70px;
        }
      }
      .itemThree {
        flex: 4;
        .itemThreeItem {
          display: flex;
          margin-bottom: 10px;
          i {
            flex: 1;
            font-size: 35px;
          }
          span {
            flex: 1;
            line-height: 35px;
          }
          .el-link {
            flex: 1;
            line-height: 35px;
            justify-content: start;
          }
        }
        .wei {
          i {
            color: red;
          }
        }
      }
    }
  }
  .itemLabLast {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      width: 120px;
      height: 120px;
      border-radius: 50%;
    }
  }
}
.box-card {
  margin-top: 10px;
}
.resCenter {
  span {
    float: left;
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: rgba(245, 249, 255, 1);
    margin-right: 20px;
  }
}

.editList {
  .el-link {
    margin-right: 20px;
  }
}
</style>